var map = {
	"./amex.png": "3643",
	"./aura.png": "ff40",
	"./background-image.png": "6f45",
	"./bandeira.png": "d656",
	"./chip.png": "8f84",
	"./dinersclub.png": "c7b9",
	"./dinners.png": "c82c",
	"./discover.png": "0a72",
	"./elo.png": "9fe8",
	"./hipercard.png": "46b5",
	"./img-perfil.png": "4d61",
	"./jcb.png": "5b45",
	"./logo-marca.png": "d342",
	"./logo-paypal.png": "217f",
	"./logo-pix.png": "cfc1",
	"./logo.png": "4ffd",
	"./logocartoes/american-express.png": "1af4",
	"./logocartoes/amex.png": "0a77",
	"./logocartoes/aura.png": "2afd",
	"./logocartoes/diners.png": "9923",
	"./logocartoes/dinersclub.png": "71a5",
	"./logocartoes/discover.png": "9447",
	"./logocartoes/elo.png": "bfbe",
	"./logocartoes/hipercard.png": "44ce",
	"./logocartoes/jcb.png": "d3c2",
	"./logocartoes/maestro.png": "5f30",
	"./logocartoes/mastercard.png": "396f",
	"./logocartoes/visa.png": "4ea6",
	"./logocartoes/visaelectron.png": "749b",
	"./maestro.png": "1fc2",
	"./mastercard.png": "ff57",
	"./saldo-monetizze.png": "d841",
	"./visa.png": "073b",
	"./visaelectron.png": "53ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";